.backBtn {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    background: none;
    border: none;
    color: #3b82f6;
    font-size: 0.875rem;
    cursor: pointer;
    padding: 0.8rem 1rem;
    width: fit-content;

    &:hover {
        text-decoration: underline;
    }
}